import { computed as e, createElementBlock as t, defineComponent as n, mergeProps as r, openBlock as i, renderSlot as a, unref as o } from "vue";
import { useBindCx as s } from "@scalar/use-hooks/useBindCx";
//#region src/shared/Badge.vue?vue&type=script&setup=true&lang.ts
var c = /*@__PURE__*/ n({
	inheritAttrs: !1,
	__name: "Badge",
	props: { color: {} },
	setup(n) {
		let { cx: c } = s(), l = e(() => n.color ? { "--badge-color": n.color } : void 0);
		return (e, s) => (i(), t("div", r(o(c)("badge inline-block rounded-2xl border bg-b-2 px-1.5 py-0.5 text-c-2 text-sm", { "badge-colored": !!n.color }), { style: l.value }), [a(e.$slots, "default", {}, void 0, !0)], 16));
	}
});
//#endregion
export { c as default };

//# sourceMappingURL=Badge.vue_vue_type_script_setup_true_lang.js.map